<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.1115 5.33318C15.1115 3.49232 13.6191 2 11.7782 2C9.93721 2 8.44482 3.49232 8.44482 5.33318V10.8885C8.44482 12.7293 9.93721 14.2217 11.7782 14.2217C13.6191 14.2217 15.1115 12.7293 15.1115 10.8885V5.33318Z"
      stroke="#64748B"
      stroke-width="1.5"
      stroke-linejoin="round"
    />
    <path
      d="M4 10.8896C4 11.911 4.20118 12.9223 4.59205 13.8659C4.98292 14.8095 5.55582 15.6669 6.27806 16.3891C7.00029 17.1113 7.85771 17.6842 8.80135 18.0751C9.74499 18.4659 10.7564 18.6671 11.7778 18.6671C12.7992 18.6671 13.8106 18.4659 14.7542 18.0751C15.6978 17.6842 16.5553 17.1113 17.2775 16.3891C17.9997 15.6669 18.5726 14.8095 18.9635 13.8659C19.3544 12.9223 19.5556 11.911 19.5556 10.8896M11.7778 22.0003V19.7781"
      stroke="#64748B"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: "audio-icon",
};
</script>
